/* Collection home header (sections/pb-collection-home.liquid).
   Tabs: set filter.p.product_type on the product grid and re-render it through the grid's own filter handler.
   Theme chips (and the sidebar theme list on these pages): narrow by tag in the path, keep every other filter.
   Chip counts and sizes: products per theme for the open tab, read once per tab from the storefront API. */
(function () {
  'use strict';
  var D = document;
  var root = D.querySelector('[data-pbch2]');
  if (!root || root._on) return;
  root._on = true;
  var base = root.getAttribute('data-base');
  var coll = root.getAttribute('data-coll');
  var MAP = {};
  try { var mj = D.querySelector('[data-pbch2-map]'); if (mj) MAP = JSON.parse(mj.textContent); } catch (e) {}

  function gridEl() { return D.querySelector('[x-data^="xFiltersAndSortby"]'); }
  function grid() { var g = gridEl(); try { return g && window.Alpine && window.Alpine.$data ? window.Alpine.$data(g) : null; } catch (e) { return null; } }
  /* the path may carry one tab tag (acc-*) and one theme tag, joined with + */
  function pathTags() { var p = location.pathname.replace(/\/$/, ''), b = base.replace(/\/$/, ''); return p.indexOf(b + '/') === 0 ? decodeURIComponent(p.slice(b.length + 1)).toLowerCase().split('+').filter(Boolean) : []; }
  function curTab() { var t = pathTags().filter(function (x) { return x.indexOf('acc-') === 0; }); return t[0] || ''; }
  function curTag() { var t = pathTags().filter(function (x) { return x.indexOf('acc-') !== 0; }); return t[0] || ''; }
  function pathFor(tab, tag) { var a = []; if (tab) a.push(tab); if (tag) a.push(tag); return base + (a.length ? '/' + a.map(encodeURIComponent).join('+') : ''); }
  function curParams() { var s = new URLSearchParams(location.search); s.delete('page'); s.delete('section_id'); return s; }
  function typesOf(s) { return (s || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean); }
  function sameSet(a, b) { if (a.length !== b.length) return false; var x = a.slice().sort(), y = b.slice().sort(); for (var i = 0; i < x.length; i++) if (x[i] !== y[i]) return false; return true; }

  var lastPath = location.pathname;
  function render(params, path, push) {
    var g = grid();
    var qs = params.toString();
    var url = path + (qs ? '?' + qs : '');
    if (!g || typeof g._renderPage !== 'function') { location.href = url; return; }
    D.documentElement.classList.add('pbch2-busy');
    if (push) { try { history.pushState({ searchParams: qs }, '', url); } catch (e) {} }
    lastPath = path;
    g.cachedResults = [];
    g._renderPage(qs, false);
    sync();
  }

  /* tab and chip state from the URL */
  function sync() {
    var on = curParams().getAll('filter.p.product_type');
    root.querySelectorAll('.pbch2__tab').forEach(function (t) {
      var ty = typesOf(t.getAttribute('data-types'));
      t.setAttribute('aria-selected', String((t.getAttribute('data-tag') || '') === curTab() && (ty.length ? sameSet(ty, on) : on.length === 0)));
    });
    var tag = curTag();
    root.querySelectorAll('.pbch2__chip').forEach(function (c) { c.setAttribute('aria-pressed', String((c.getAttribute('data-tag') || '') === tag)); });
    D.querySelectorAll('.pb-theme-links a[data-pbch-tag]').forEach(function (a) {
      var on2 = (a.getAttribute('data-pbch-tag') || '') === tag;
      a.classList.toggle('is-on', on2); if (on2) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
    });
    counts();
  }

  root.addEventListener('click', function (e) {
    var t = e.target.closest('.pbch2__tab');
    if (t) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var p = curParams(); p.delete('filter.p.product_type');
      typesOf(t.getAttribute('data-types')).forEach(function (ty) { p.append('filter.p.product_type', ty); });
      render(p, pathFor(t.getAttribute('data-tag') || '', curTag()), true);
      return;
    }
    var c = e.target.closest('.pbch2__chip');
    if (c) {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return;
      e.preventDefault();
      var tg = c.getAttribute('data-tag') || '';
      render(curParams(), pathFor(curTab(), tg), true);
    }
  });
  /* the sidebar theme list (snippets/pb-theme-links) works the same way on these pages */
  D.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.pb-theme-links a[data-pbch-tag]');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey) return;
    e.preventDefault();
    var tg = a.getAttribute('data-pbch-tag') || '';
    if (tg === curTag()) tg = '';
    render(curParams(), pathFor(curTab(), tg), true);
  });
  /* back and forward across themes: the grid's own handler only watches the query string */
  window.addEventListener('popstate', function () {
    if (location.pathname !== lastPath) {
      var g = grid(); lastPath = location.pathname;
      if (g && g._renderPage) { D.documentElement.classList.add('pbch2-busy'); g.cachedResults = []; g.searchParamsPrev = location.search.slice(1); g._renderPage(location.search.slice(1), false); }
    }
    setTimeout(sync, 0);
  });
  /* the grid re-renders (tabs, chips, sidebar filters, sort): refresh the tab and chip state */
  function watchGrid() {
    var pc = D.getElementById('ProductGridContainer');
    if (!pc || !window.MutationObserver) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(function () { D.documentElement.classList.remove('pbch2-busy'); sync(); }, 60); }).observe(pc, { childList: true });
  }

  /* tabs set to hide when empty start hidden; one storefront read per tab tag shows the tab once a product carries it */
  root.querySelectorAll('.pbch2__tab[data-pbch-ifany]').forEach(function (t) {
    var tg = t.getAttribute('data-tag'); if (!tg) return;
    var Q = 'query($q:String!){products(first:1,query:$q){nodes{id}}}';
    fetch('/api/2026-04/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: Q, variables: { q: "tag:'" + tg + "'" } }) })
      .then(function (r) { return r.json(); })
      .then(function (j) { var p = j && j.data && j.data.products; if (p && p.nodes.length) t.hidden = false; })
      .catch(function () {});
  });

  var cache = {}, mapGrew = false;
  function key(types, tab) { return 'pbch2:' + coll + ':' + (tab ? tab + ':' : '') + (types.slice().sort().join('|') || '*'); }
  function fetchTags(types, tab) {
    var k = key(types, tab);
    if (cache[k]) return cache[k];
    try { var s = sessionStorage.getItem(k); if (s) { var o = JSON.parse(s); if (o && o.t > Date.now() - 36e5) return (cache[k] = Promise.resolve(o.v)); } } catch (e) {}
    var filters = types.map(function (t) { return { productType: t }; });
    var Q = 'query($h:String!,$a:String,$f:[ProductFilter!]){collection(handle:$h){products(first:250,after:$a,filters:$f){pageInfo{hasNextPage endCursor} nodes{tags}}}}';
    var out = { n: 0, by: {} };
    function page(after, guard) {
      return fetch('/api/2026-04/graphql.json', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ query: Q, variables: { h: coll, a: after, f: filters } }) })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var p = j && j.data && j.data.collection && j.data.collection.products;
          if (!p) throw new Error('no data');
          p.nodes.forEach(function (n) {
            if (tab && !(n.tags || []).some(function (tg) { return tg.toLowerCase() === tab; })) return;
            out.n++;
            var seen = {};
            (n.tags || []).forEach(function (tg) { var h = tg.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); if (MAP[h] !== undefined && !seen[h]) { seen[h] = 1; out.by[h] = (out.by[h] || 0) + 1; } });
          });
          if (p.pageInfo.hasNextPage && guard < 8) return page(p.pageInfo.endCursor, guard + 1);
          return out;
        });
    }
    var pr = page(null, 0).then(function (v) { try { sessionStorage.setItem(k, JSON.stringify({ t: Date.now(), v: v })); } catch (e) {} return v; });
    pr.catch(function () { delete cache[k]; });
    return (cache[k] = pr);
  }
  var tok = 0;
  function counts() {
    var chips = root.querySelectorAll('.pbch2__chip[data-tag]:not([data-tag=""])');
    var side = D.querySelectorAll('.pb-theme-links a[data-pbch-tag]');
    if (!chips.length && !side.length) return;
    side.forEach(function (a) { var h = a.getAttribute('data-pbch-tag'); if (h && MAP[h] === undefined) { MAP[h] = h; mapGrew = true; } });
    if (mapGrew) { cache = {}; mapGrew = false; try { Object.keys(sessionStorage).forEach(function (k) { if (k.indexOf('pbch2:') === 0) sessionStorage.removeItem(k); }); } catch (e) {} }
    var my = ++tok, types = curParams().getAll('filter.p.product_type');
    fetchTags(types, curTab()).then(function (v) {
      if (my !== tok) return;
      var max = 1; Object.keys(v.by).forEach(function (h) { if (v.by[h] > max) max = v.by[h]; });
      chips.forEach(function (c) {
        var n = v.by[c.getAttribute('data-tag')] || 0, r = n / max;
        var lv = n === 0 ? 1 : r >= 0.85 ? 5 : r >= 0.55 ? 4 : r >= 0.3 ? 3 : r >= 0.12 ? 2 : 1;
        c.className = c.className.replace(/pbch2__chip--\d/, 'pbch2__chip--' + lv);
        c.classList.toggle('is-empty', n === 0);
        var s = c.querySelector('[data-n]'); if (s) s.textContent = String(n);
        c.setAttribute('title', n + (n === 1 ? ' product' : ' products'));
      });
      side.forEach(function (a) {
        var n = v.by[a.getAttribute('data-pbch-tag')] || 0, s = a.querySelector('[data-n]');
        if (s) s.textContent = '(' + n + ')';
        var li = a.closest('li'); if (li) li.hidden = n === 0 && a.getAttribute('data-pbch-tag') !== curTag();
      });
    }).catch(function () {});
  }

  function boot() { watchGrid(); sync(); }
  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
})();
